import { SettingsService } from '@inter-ikea-kompis/services';
import { getCustomLocale } from '../utils/i18nUtils';
import { e2e, getQuery, getRange } from '../utils/queryUtils';
import { DexfSettingsEnvironmentEnum } from '@inter-ikea-kompis/enums';
import { getDexfApiKey } from './dexfApiKey';
import { isKiosk } from '../utils/platform';
import { DexfSettingsFilterSegmentEnum } from '@inter-ikea-kompis/enums';
import { Environment } from '../enums/Environment';
import { getEnvironment } from '../utils/platform';
import { getMemoizedPromiseFactory, PROMISE_CACHE } from '../utils/getMemoizedPromiseFactory';
import { replacePathSegment } from '../utils/pathUtils';
import { getStoredToken, isTokenValid, removeStoredToken, shouldUseProxyToken } from '../utils/proxyTokenUtils';
export const getDexfSettingsFilterSegment = () => {
    const environment = getEnvironment();
    if (environment === Environment.DEVELOPMENT) {
        return DexfSettingsFilterSegmentEnum.development;
    }
    else if (environment === Environment.VERIFICATION ||
        environment === Environment.VERIFICATION_PR) {
        return DexfSettingsFilterSegmentEnum.verification;
    }
    return DexfSettingsFilterSegmentEnum.production;
};
const getDexfSettingOverrideSettings = () => {
    const forceDisableSaveToProfile = !e2e() && isKiosk();
    const forceEnableSaveToProfile = e2e();
    const unitSystem = getQuery().get('unitSystem');
    const forceDisableMetricMeasures = unitSystem === 'imperial';
    const forceEnableMetricMeasures = unitSystem === 'metric';
    const useProxyToken = shouldUseProxyToken();
    return {
        forceDisableSaveToProfile,
        forceEnableSaveToProfile,
        forceDisableMetricMeasures,
        forceEnableMetricMeasures,
        useProxyToken
    };
};
const _getDexfSettings = async (langCode) => {
    const range = getRange();
    const locale = getCustomLocale(langCode);
    const dexfApiKey = getDexfApiKey(range);
    const { forceDisableSaveToProfile, forceEnableSaveToProfile, forceDisableMetricMeasures, forceEnableMetricMeasures, useProxyToken } = getDexfSettingOverrideSettings();
    const dexfSettingsFilterSegment = getDexfSettingsFilterSegment();
    const dexfApplicationId = `storageone${range}`;
    const settingsService = new SettingsService({
        dexfApiKey,
        dexfEnvironment: DexfSettingsEnvironmentEnum.production,
        dexfApplicationId,
        locale
    });
    const dexfSettingsRaw = await settingsService.getApplicationSettings(dexfSettingsFilterSegment);
    const settings = dexfSettingsRaw;
    if (forceEnableMetricMeasures) {
        settings.localisation.useMetricMeasures = true;
    }
    if (forceDisableMetricMeasures) {
        settings.localisation.useMetricMeasures = false;
    }
    // Force save to profile enabled in e2e and disabled on kiosk
    if (forceEnableSaveToProfile) {
        settings.general.enableSaveToProfile = true;
    }
    if (forceDisableSaveToProfile) {
        settings.general.enableSaveToProfile = false;
    }
    if (useProxyToken) {
        const { dexfWebplannerService } = settings.kompis.endpoints;
        const storedToken = getStoredToken();
        if (!storedToken || !isTokenValid()) {
            removeStoredToken();
        }
        else {
            settings.kompis.endpoints.dexfWebplannerService = replacePathSegment(dexfWebplannerService, 'query', ['proxy', storedToken.token]);
        }
    }
    return settings;
};
export const clearDexfSettingsCache = () => PROMISE_CACHE.delete(_getDexfSettings);
// getMemoizedPromiseFactory ensures that if we have multiple calls for getDexfSettings() the callers
//   get back the same result without creating duplicate requests/responses
export const getDexfSettings = getMemoizedPromiseFactory(_getDexfSettings);
//# sourceMappingURL=dexfSettingsService.js.map